import React from "react";
import ReactTooltip from "react-tooltip";
import classes from "./triviainput.module.scss";
import { nanoid } from "nanoid";
import { PlainText } from "../../Text/Text";
import { IsMobile } from "../../../utilities/util";
export interface ITriviaInput
  extends React.InputHTMLAttributes<HTMLInputElement> {
  onValueChanged?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  color?: string;
  border?: boolean;
  maxLength?: number;
  icon?: string;
  tooltipText?: string;
  containerStyles?: React.CSSProperties;
  tooltipClass?: string;
}

const TriviaInput: React.FC<ITriviaInput> = ({
  onValueChanged = (e) => {},
  color,
  maxLength,
  border,
  icon,
  tooltipText,
  children,
  containerStyles,
  id,
  tooltipClass,
  ...rest
}) => {
  const InputId = nanoid(10);
  const onValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.pattern === "") {
      onValueChanged(e);
    } else {
      var regPat = new RegExp(e.target.pattern);
      if (regPat.test(e.target.value)) {
        onValueChanged(e);
      } else {
        e.target.value = "";
      }
    }
  };
  return (
    <div className={classes["input-container"]} style={containerStyles}>
      <input
        style={{
          color: color || "#222027",
          border: border ? "" : "none",
          ...rest.style,
        }}
        {...rest}
        id={id}
        className={`${classes["input-field"]} ${rest.className}`}
        onChange={onValueChange}
        maxLength={maxLength}
        autoComplete={IsMobile() ? "new-password" : "off"}
      ></input>
      {icon ? (
        <img
          className={`${classes["tooltip"]} ${tooltipClass}`}
          width={24}
          height={24}
          src={icon}
          data-tip
          data-for={InputId}
          alt=""
        ></img>
      ) : null}

      <ReactTooltip
        id={InputId}
        type="error"
        effect="solid"
        backgroundColor="#B91213"
        multiline

        // class={classes["tooltipText"]}
      >
        <PlainText>{children}</PlainText>
      </ReactTooltip>
    </div>
  );
};

export default TriviaInput;
